import MockAdapter from 'axios-mock-adapter';
import { UserData } from '../../hooks/api/users/useUserList';

export function userMocks(mock: MockAdapter): void {
  mock
    .onGet(
      /\/api\/organizations\/[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}\/users(\?.+)?$/,
    )
    .reply(() => {
      const result: UserData = {
        page: 1,
        totalCount: 5,
        pageSize: 5,
        data: [
          {
            id: '00000000-0000-0000-0000-000000000001',
            email: 'user1@example.com',
            name: 'User One',
            firstname: 'User',
            avatar:
              'https://localhost:44301/api/organization/file/717cc5ea-7148-44c9-8041-2c5c6339f333/1f4756d2-4a39-4bf2-bbeb-691b210815a1',
          },
          {
            id: '00000000-0000-0000-0000-000000000002',
            email: 'user2@example.com',
            name: 'User Two',
            firstname: 'User',
            avatar: null,
          },
          {
            id: '00000000-0000-0000-0000-000000000003',
            email: 'user3@example.com',
            name: 'User Three',
            firstname: 'User',
            avatar: null,
          },
          {
            id: '00000000-0000-0000-0000-000000000004',
            email: 'user4@example.com',
            name: 'User Four',
            firstname: 'User',
            avatar: null,
          },
          {
            id: '00000000-0000-0000-0000-000000000005',
            email: 'user5@example.com',
            name: 'User Five',
            firstname: 'User',
            avatar: null,
          },
        ],
      };
      return [200, result];
    });
}
